import './Footer.css'

const Footer = () => {


  return (<div className="terms-footer">
  <div className="terms-link">
    <a href="/terms">Terms</a>
  </div>
  <div className="terms-link">
    <a href="/privacy"> Privacy</a>
  </div>
  <div className='terms-link'>© newsie-fyi, LLC</div>
</div>)
};

export default Footer;